import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import custom from './custom'
import GrantCustom from '@/modules/grant-allowance-service/store/custom'
import SourceCustom from '@/store/custom'
import HospitalDisabilityServiceCustom from '@/modules/hospital-disability-service/store/custom'

const state = {
    activePanel: null,
    panelObj: {
        irriUserLoader: false,
        irriUserStatus: 0,
        lrcpnUserLoader: false,
        lrcpnUserStatus: 0,
        ginnerGrowerLoader: false,
        ginnerGrowerMessage: '',
        divisionalHeadLoader: false,
        divisionalHeadMessage: '',
        dealerLoader: false,
        dealerMessage: '',
        trainigLoader: false,
        trainingMessage: '',
        incentiveFarmerLoader: false,
        incentiveFarmerMesage: '',
        researchFarmerLoader: false,
        profileStatus: 2
    },
    commonProfile: {
        user_id: '',
        name: '',
        name_bn: '',
        mobile_no: '',
        email: '',
        father_name: '',
        father_name_bn: '',
        mother_name: '',
        mother_name_bn: '',
        gender: '',
        region_id: '',
        division_id: '',
        district_id: '',
        upazila_id: '',
        union_id: '',
        nid: '',
        image: ''
    },
    commonObj: {
        beneficiaryAccountType: SourceCustom.beneficiaryAccountType,
        bankAccountType: SourceCustom.bankAccountType,
        mfsService: SourceCustom.mfsService,
        dateFormat: 'DD/MM/YYYY',
        fiscaleYear: 'YYYY-YYYY',
        timeFormat: 'h:m',
        loading: false,
        listReload: false,
        orgList: [],
        hasDropdownLoaded: false,
        countryList: [],
        divisionList: [],
        districtList: [],
        upazilaList: [],
        unionList: [],
        perPage: 10,
        fileSize: 2097152,
        reasonList: custom.reasonList,
        genderList: custom.genderList,
        burnPatientTypeList: custom.burnPatientTypeList,
        healthConditionList: custom.healthConditionList,
        studentGenderList: custom.studentGenderList,
        studyingClassList: custom.studyingClassList,
        studentClassList: custom.studentClassList,
        religionList: custom.religionList,
        meritalStatuslList: custom.meritalStatuslList,
        wardTypeList: custom.wardTypeList,
        paymentStatusList: custom.paymentStatusList,
        applicationTypeList: custom.applicationTypeList,
        qoutaList: custom.qoutaList,
        bloodGroupList: custom.bloodGroupList,
        subServiceTypeList: custom.subServiceTypeList,
        diseaseList: custom.diseaseList,
        organizationProfileList: [],
        orgComponentList: [],
        officeList: [],
        cityCorporationList: [],
        pauroshobaList: [],
        wardList: [],
        fiscalYearList: [],
        hospitalCategoryList: custom.hospitalCategoryList,
        applicationClassList: custom.applicationClassList,
        accountTypeList: custom.accountTypeList,
        formTypeList: custom.formTypeList,
        specialCategoryList: custom.specialCategoryList,
        monthList: custom.monthList,
        subOccupationList: custom.subOccupationList,
        subOccupationListx: custom.subOccupationListx,
        registrationTypeList: [
            {
                value: 1,
                text_en: 'Dealer',
                text_bn: 'ব্যবসায়ী'
            },
            {
                value: 2,
                text_en: 'Retailer',
                text_bn: 'খুচরা বিক্রেতা'
            }
        ],
        paymentTypeList: [
            {
                value: 1,
                text_en: 'Online Payment',
                text_bn: 'অনলাইন পেমেন্ট'
            },
            {
                value: 2,
                text_en: 'Check Payment',
                text_bn: 'চেক পেমেন্ট'
            },
            {
                value: 3,
                text_en: 'Cash Payment',
                text_bn: 'ক্যাশ পেমেন্ট'
            }
        ]
    },
    productionCommonObj: {
        productCategoryList: [],
        productSubCategoryList: [],
        productList: [],
        productUnitList: [],
        dealerRetailerList: []
    },
    hospitalCommonObj: {
        hospitalInfoList: [],
        hospitalTypeList: custom.hospitalTypeList,
        patientTypeList: HospitalDisabilityServiceCustom.patientTypeList,
        patientDisabilityTypesList: HospitalDisabilityServiceCustom.patientDisabilityType,
        centerTypeList: HospitalDisabilityServiceCustom.centerTypeList,
        therapyCenterList: [],
        campaignCenterList: [],
        educationalQualificationList: HospitalDisabilityServiceCustom.educationalQualificationList,
        occupationList: HospitalDisabilityServiceCustom.occupationList,
        typeHouseList: HospitalDisabilityServiceCustom.typeHouseList,
        monthlyIncomeList: HospitalDisabilityServiceCustom.monthlyIncomeList,
        iDInformationList: HospitalDisabilityServiceCustom.iDInformationList,
        disabilityInformationList: HospitalDisabilityServiceCustom.disabilityInformationList,
        disabilityTypesList: []
    },
    patientCommonObj: {
        hasDropdownLoaded: true,
        maritalStatusList: custom.maritalStatus,
        genderList: custom.genderList,
        educationalBoardList: custom.educationalBoardList,
        educationalResultTypeList: custom.educationalResultTypeList,
        serviceTypeList: [],
        patientCategoryList: [],
        educationLevelList: [],
        degreeList: [],
        disabilityTypeList: [],
        skillList: [],
        instituteList: [],
        groupList: [],
        centerList: [],
        circularList: [],
      assistiveDeviceList: []
    },
    stallParticipantCommonObj: {
        hasDropdownLoaded: true,
        eventTypeList: [],
        eventList: [],
        stallTypeList: [],
        stallList: [],
        fairStallList: []
    },
    grantCommonObj: {
        serviceNameList: [],
        hospitalList: [],
        instituteList: [],
        applicationToList: GrantCustom.applicationToList,
        nomineeRelationList: GrantCustom.nomineeRelationList
    },
    trainingCommonObj: {
        hasDropdownLoaded: true,
        batchList: [],
        evaluationNameList: [],
        docTypeList: [],
        trainingNameList: [],
        organizationTypeList: [],
        eduQualificationList: [],
        designationList: [],
        circularMemoList: [],
        registeredOrgList: []
    },
    employerCommonObj: {
        serviceTypeList: [],
        patientCategoryList: [],
        disabilityTypeList: [],
        groupList: [],
        instituteList: [],
        skillList: [],
        educationLevelList: [],
        circularList: [],
        degreeList: []
    },
    static: {
        loading: false
    }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
